import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../store/base.graphql";
import {UserTypesEnum} from "../../shared/enums/user-types.enum";
import {institutionFields} from "../../store/entities/system-settings/institution/institution.graphql";
import {designationFields} from "../../store/entities/instution-settings/designation/designation.graphql";


export interface ProfileObject {
  id?: string
  profileUniqueId?: string
  userFirstName?: string
  userLastName?: string
  userEmail?: string
  profilePhone?: string
  profileTitle?: string
  profilePhoto?: string
  profileType?: UserTypesEnum
}

export interface InstitutionObject {
  id?: string
}


export const profileFields = `
id
profileUniqueId
userFirstName
userLastName
userEmail
profilePhone
profileTitle
profilePhoto
profileType
`

export const roleFields = `
id
roleUniqueId
roleName
roleIsAdmin
roleIsSystemDefault
roleDescription
`

export const permissionFields = `
id
permissionUniqueId
permissionName
permissionCode
`


export const GET_USER_PROFILE = gql`
  query GetUserProfileAndRole {
    getUserProfileAndRole {
      ${baseResponseGraphqlField}
      data {
        profile {
          ${profileFields}
        }
        role {
          ${roleFields}
          rolePermissions {
            ${permissionFields}
          }
        }
        institution {
          ${institutionFields}
        }
        userDesignation {
          ${designationFields}
        }
      }
    }
  }

`

export const GET_COMPANY_REPRESENTATIVE_PROFILE = gql`
  query GetCompanyRepresentativeProfile {
    getCompanyRepresentativeProfile {
      ${baseResponseGraphqlField}
      data {
        id
        uniqueId
        representative {
          id
          profileUniqueId
          userFirstName
          userLastName
          userEmail
          profilePhone
          profileTitle
          profilePhoto
          profileIsActive
          profileIsDeactivated
          profileType
          userDesignation {
            id
            designationUniqueId
            designationShortForm
            designationName
          }
          role {
            id
            roleUniqueId
            roleName
            roleIsAdmin
            roleIsSystemDefault
            roleDescription
            rolePermissions {
              id
              permissionUniqueId
              permissionName
              permissionCode
            }
          }
        }
        company {
          id
          uuid
          companyRegNumber
          taxPayerTin
          companyName
          shortForm
          mobPhone
          box
          email
          country
          isVerified
        }
      }
    }
  }

`
export const GET_COMPANY_REPRESENTATIVES = gql`
  query GetCompanyRepresentatives($companyUniqueId: String) {
    getCompanyRepresentatives(companyUniqueId: $companyUniqueId) {
      response {
        id
        status
        code
        message
      }
      data {
        id
        uniqueId
        representative {
          id
          profileUniqueId
          userFirstName
          userLastName
          userEmail
          profilePhone
          profileTitle
          profilePhoto
          profileIsActive
          profileIsDeactivated
          profileType
          userDesignation {
            id
            designationUniqueId
            designationShortForm
            designationName
          }
          role {
            id
            roleUniqueId
            roleName
            roleIsAdmin
            roleIsSystemDefault
            roleDescription
            rolePermissions {
              id
              permissionUniqueId
              permissionName
              permissionCode
            }
          }
        }
        company {
          id
          uuid
          companyRegNumber
          taxPayerTin
          companyName
          shortForm
          mobPhone
          box
          email
          country
          isVerified
        }
      }
    }
  }
`

export const GET_USER_PROFILE_FEW_FIELDS = gql`
  query GetUserProfileAndRole {
    getUserProfileAndRole {
      ${baseResponseGraphqlField}
      data {
        profile {
          ${profileFields}
        }
      }
    }
  }

`

export const GET_CAPTCHA = gql`
  query GetCaptcha {
    getCaptcha {
      ${baseResponseGraphqlField}
      data {
        captchaText
        captchaImage
      }
    }
  }`

export const VERIFY_CAPTCHA_MUTATION = gql`
  mutation VerifyCaptchaMutation($captchaText: String!, $userInput: String!) {
    verifyCaptchaMutation(captchaText: $captchaText, userInput: $userInput) {
      ${baseResponseGraphqlField}
    }
  }`
